import personCardNewTpl from './person-card-new.tpl.html';
import personCardCompactTpl from './person-card-compact.tpl.html';
import personCardFullTpl from './person-card-full.tpl.html';

import navButtonComponentMod from '../../common/material-components/buttons/nav-button.component';
import normalButtonComponentMod from '../../common/material-components/buttons/normal-button.component';
import normButtonComponentMod from '../../common/material-components/buttons/norm-button.component';

import nonCompatibleNotification from '../reservation/selections/non-compatible-notification.component';

import urlServiceMod from '../common/url.service';

/**
 * Displays the details of a person in the persons page
 */
class PersonCardComponent {

  constructor($window, $log, UrlService) {
    'ngInject';

    this.$window = $window;
    this.$log = $log;
    this.UrlService = UrlService;

    /**
     * Person object for this card.
     * @type {Person}
     */
    this.personObj = {};

    this.personInfoCallback = null;

    this.compactMode = false;
    this.showInfo = false;

    /**
     * Mode where only name and title are shown of the person.
     * @type {boolean}
     */
    this.nameAndTitleMode = false;

    /**
     * Should the card display as active (green background)
     * @type {boolean}
     */
    this.active = false;


    /**
     * To allow reservation links to have correct parameters service ID can be set.
     */
    this.serviceId = null;
    /**
     * To allow reservation links to have correct parameters location ID can be set.
     */
    this.locationId = null;

    this.oldMatches = [];

    this.showReserveLink = false;
  }

  $onInit() {
    this.personId = `person-${this.personObj.id}`;
    this.showReserveLink = !this.compactMode && this.personObj.hasService && !this.personObj.isOffline;
    this.reservationUrl = '';
    this.UrlService.reservationURL(this._reservationParams())
      .then(url => this.reservationUrl = url);
  }

  $doCheck() {
    const newMatches = angular.toJson(this.personObj.matches);
    if (!angular.equals(this.oldMatches, newMatches)) {
      this.oldMatches = newMatches;
      this.updateMatches();
    }
  }

  updateMatches() {
    // Create a string list of matches that are not directly visible, items are concatenated with comma
    try {
      const restOfMatches = [];
      if (this.personObj.matches) {
        this.$log.debug("Update matches", this.personObj.first_name, this.personObj.matches);

        for (const prop of ["spoken_language_names", "group_names", "category_names"]) {
          if (prop in this.personObj.matches) {
            restOfMatches.push(this.personObj.matches[prop].values.join(', '));
          }
        }
        this.personObj.restOfMatches = restOfMatches.join(', ');
      }
    }
    catch (e) {
      this.$log.debug("Person matches can't be set");
    }
  }


  onPersonInfoClicked(event) {
    event.stopPropagation();
    this.personInfoCallback({person: this.personObj});
  }

  _reservationParams() {
    return {
      personId: this.personObj.id,
      serviceId: this.serviceId,
      locationId: this.locationId
    };
  }
}

const config = {
  templateUrl: function($element, $attrs, $log) {
    $log.debug("Determine template for person", $attrs.newMode, $attrs.compactMode);
    // Attrs are unevaluated.
    if($attrs.newMode === "true") {
      return personCardNewTpl;
    } else {
      if ($attrs.compactMode === "true") {
        return personCardCompactTpl;
      }
      else {
        return personCardFullTpl;
      }
    }
  },
  controller: PersonCardComponent,
  bindings: {
    personObj: '<',
    compactMode: '<',
    newMode: '<?',
    nameAndTitleMode: '<?',
    showInfo: '<?',
    personInfoCallback: '&?',
    active: '<?',
    serviceId: '<?',
    locationId: '<?',
  }
};

const mod = angular.module('app.personCard', [
    urlServiceMod, navButtonComponentMod, normalButtonComponentMod, normButtonComponentMod, nonCompatibleNotification
  ])
    .component('personCard', config)
;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/persons/person-card.component.js